export default {
  setModules: (state, payload) => {
    state.modules = payload;
  },

  setDefaultModule: (state, payload) => {
    state.defaultModule = payload;
  },

  logoff: (state) => {
    state.defaultModule = null;
    state.modules = [];
  },

  setModulesAllowed: (state, payload) => {
    state.modulesAllowed = payload;
  }
};
